/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU16Decoder,
  getU16Encoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtLockPosition = {
  pool: Address;
  position: Address;
  owner: Address;
  vesting: Address;
  cliffPoint: bigint;
  periodFrequency: bigint;
  cliffUnlockLiquidity: bigint;
  liquidityPerPeriod: bigint;
  numberOfPeriod: number;
};

export type EvtLockPositionArgs = {
  pool: Address;
  position: Address;
  owner: Address;
  vesting: Address;
  cliffPoint: number | bigint;
  periodFrequency: number | bigint;
  cliffUnlockLiquidity: number | bigint;
  liquidityPerPeriod: number | bigint;
  numberOfPeriod: number;
};

export function getEvtLockPositionEncoder(): FixedSizeEncoder<EvtLockPositionArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["vesting", getAddressEncoder()],
    ["cliffPoint", getU64Encoder()],
    ["periodFrequency", getU64Encoder()],
    ["cliffUnlockLiquidity", getU128Encoder()],
    ["liquidityPerPeriod", getU128Encoder()],
    ["numberOfPeriod", getU16Encoder()],
  ]);
}

export function getEvtLockPositionDecoder(): FixedSizeDecoder<EvtLockPosition> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["vesting", getAddressDecoder()],
    ["cliffPoint", getU64Decoder()],
    ["periodFrequency", getU64Decoder()],
    ["cliffUnlockLiquidity", getU128Decoder()],
    ["liquidityPerPeriod", getU128Decoder()],
    ["numberOfPeriod", getU16Decoder()],
  ]);
}

export function getEvtLockPositionCodec(): FixedSizeCodec<
  EvtLockPositionArgs,
  EvtLockPosition
> {
  return combineCodec(getEvtLockPositionEncoder(), getEvtLockPositionDecoder());
}
